module.exports = __webpack_public_path__ + "img/shapes.e5cad644.png";